import React from 'react';
import { Pie } from '@ant-design/plots';
const AudienceGenderStatsComponent = ({ genderStats }) => {
  const config = {
    appendPadding: 10,
    data: genderStats,
    angleField: 'value',
    colorField: 'type',
    radius: 1,
    innerRadius: 0.6,
    label: {
      type: 'inner',
      offset: '-50%',
      content: '{value}',
      style: {
        textAlign: 'center',
        fontSize: 14,
      },
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },
  };
  return (
    <div>
      <h6> <strong>Gender</strong></h6>
      <div className="d-flex p-2 "
        style={{ height: 250, justifyContent: 'center' }}>
        <Pie {...config}
        />
      </div>
    </div>
  );
};

export default AudienceGenderStatsComponent;
